const ConditionSet = ({ children }: { children: React.ReactNode }) => {
  return children;
};

export { ConditionSet };
